import type { SnapshotCardData } from '@ovComponents/3-pattern/snapshotCard';
import type { TFunction } from 'i18next';
import type { MappedSnapshotCard, SnapshotCardKey } from './v2Mappers';

export type TranslatedSnapshotCard = SnapshotCardData & {
  cardKey: SnapshotCardKey;
};

export function translateSnapshotCards(
  cards: MappedSnapshotCard[],
  t: TFunction<'portfolioTradingHub'>,
): TranslatedSnapshotCard[] {
  return cards.map(({ cardKey, breakdown, onTrackCount, ...card }) => ({
    ...card,
    cardKey,
    title: t(`snapshotCards.${cardKey}.title`),
    secondaryStat:
      cardKey === 'needsAction'
        ? t('snapshotCards.needsAction.secondaryStat', {
            count: onTrackCount ?? 0,
          })
        : t(`snapshotCards.${cardKey}.secondaryStat`),
    breakdown: breakdown?.map((row) => ({
      label: t(`snapshotCards.${cardKey}.breakdown.${row.labelKey}`),
      value: row.value,
    })),
  }));
}
